import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import ReactDOM from "react-dom";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./reset.css";
import "./index.scss";

import { ReservationPage } from "./pages/reservation/ReservationPage";
import { ReservationContactsPage } from "./pages/reservation-contacts/ReservationContactsPage";
import { ReservationCompletePage } from "./pages/reservation-complete/ReservationCompletePage";
import { NavigateOut } from "./components/navigate-out/navigate-out";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/:organizationAlias">
        <Route index element={<Navigate to="rezervacija" />} />
        <Route path="rezervacija" element={<ReservationPage />} />
        <Route
          path="rezervacija/kontaktai"
          element={<ReservationContactsPage />}
        />
        <Route
          path="rezervacija/sekminga"
          element={<ReservationCompletePage />}
        />
      </Route>
      <Route
        path="/"
        element={<NavigateOut to="https://admin.takeblock.com" />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
